/**
* @file Skype username validator
* @author Wim Haanstra
*/
import { Validator } from 'breeze-client';
export var NAME_SKYPE_VALIDATOR = 'skype';
/**
 * This validator validates a skype username
 */
export function SkypeValidator() {
    var contxt = {};
    var validator = new Validator(NAME_SKYPE_VALIDATOR, valFunction, contxt);
    return validator;
    function valFunction(value, context) {
        var stringValue = value;
        if (!stringValue) {
            return false;
        }
        var regularExpression = /[a-zA-Z]{1}[a-zA-Z0-9\.,\-_]{5,31}/;
        return regularExpression.test(stringValue);
    }
}
Validator.messageTemplates[NAME_SKYPE_VALIDATOR] = 'APP.DOMAIN.VALIDATORS.SKYPE';
Validator.register(SkypeValidator());
